module.exports = "/shared/img/lucky-greek.png";


//////////////////
// WEBPACK FOOTER
// ./src/ui/img/lucky-greek.png
// module id = 442
// module chunks = 13